<template>
  <div class="flex flex-col items-center gap-4">

    <!-- ÁREA DO AVATAR -->
    <div
      class="relative group w-40 h-40 rounded-2xl shadow-md overflow-hidden bg-gray-200 cursor-pointer"
      @click="triggerFileInput"
    >
      <img
        v-if="modelValue"
        :src="modelValue"
        class="w-full h-full object-cover"
      />

      <!-- TEXTO QUANDO NÃO TEM IMAGEM -->
      <div
        v-else
        class="w-full h-full flex items-center justify-center text-gray-500 text-sm"
      >
        Escolher foto
      </div>

      <!-- OVERLAY DE HOVER -->
      <div
        class="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100
               transition flex items-center justify-center text-white text-sm"
      >
        Alterar
      </div>

      <!-- ÍCONE CANTO INFERIOR DIREITO -->
      <div
        class="absolute bottom-2 right-2 bg-white rounded-full p-2 shadow text-gray-700"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
             viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 10l4.553-4.553a1.5 1.5 0 00-2.121-2.121L12.879 7.879M5 21h14a2 2 0 002-2v-6M9 15l6-6" />
        </svg>
      </div>
    </div>

    <!-- INPUT INVISÍVEL -->
    <input
      ref="fileInput"
      type="file"
      accept="image/*"
      class="hidden"
      @change="onFileChange"
    />
  </div>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  modelValue: String, // preview
});

const emit = defineEmits(["update:modelValue", "file-selected"]);

const fileInput = ref(null);

const triggerFileInput = () => {
  fileInput.value.click();
};

const onFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  // Preview local instantânea
  const url = URL.createObjectURL(file);
  emit("update:modelValue", url);
  emit("file-selected", file);
};
</script>
